<template>
  <a-card hoverable>
    <createCategory
      ref="collectionForm"
      v-if="visible"
      :visible="visible"
      @cancel="visible = false"
      @create="visible = false"
      :category="category"
    />
    <shortcutView
      v-if="showShortcut"
      @ok="showShortcut = false"
      :category="category"
    />
    <template slot="actions" class="ant-card-actions">
      <a-tooltip placement="bottom" v-if="category.active">
        <template slot="title">
          <span>收藏</span>
        </template>
        <a-icon
          key="star"
          type="star"
          :theme="star ? 'filled' : 'outlined'"
          @click="handleStar"
        />
      </a-tooltip>

      <a-tooltip placement="bottom">
        <template slot="title">
          <span>编辑</span>
        </template>
        <a-icon key="edit" type="edit" @click="visible = true" />
      </a-tooltip>

      <a-tooltip placement="bottom" v-if="category.active">
        <template slot="title">
          <span>快捷方式</span>
        </template>
        <a-icon
          key="radius-bottomleft"
          type="radius-bottomleft"
          @click="showShortcut = true"
        />
      </a-tooltip>

      <a-dropdown placement="bottomLeft">
        <a-icon key="ellipsis" type="ellipsis" />
        <a-menu slot="overlay">
          <a-menu-item @click="handleArchive">
            <a-icon
              key="folder-open"
              type="folder-open"
              v-if="category.active"
            />
            <a-icon v-else type="undo" />
            <span v-if="category.active">归档</span>
            <span v-else>还原</span>
          </a-menu-item>
          <a-menu-item @click="handleDel">
            <a-icon key="delete" type="delete" />
            <span>删除</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </template>
    <a-card-meta :title="category.name" :description="category.description">
      <a-avatar slot="avatar" :style="`backgroundColor: ${category.color}`" />
      <!-- <span class="event-color" slot="avatar"></span> -->
    </a-card-meta>
  </a-card>
</template>

<script>
import createCategory from "./CategoryForm";
import shortcutView from "./CategoryShortcut";
import { mapActions } from "vuex";

export default {
  // active: (...)
  // color: (...)
  // description: (...)
  // id: (...)
  // name: (...)
  // shortcut: (...)
  // star: (...)
  props: ["category"],
  components: {
    createCategory,
    shortcutView
  },
  data() {
    return {
      visible: false,
      showShortcut: false
    };
  },
  computed: {
    archive() {
      return this.$store.getters.categorys[this.category.id].active;
    },
    star() {
      return this.$store.getters.categorys[this.category.id].star;
    }
  },
  methods: {
    async handleStar() {
      this.toggleStar(this.category.id);
    },
    handleDel() {
      this.$modal.confirm({
        title: "确定要删除这个分类吗？",
        content: "记录该分类的时间块也将被删除",
        okText: "删除",
        okType: "danger",
        cancelText: "取消",
        onOk: () => {
          this.deleteCategory(this.category.id);
        }
      });
    },
    handleArchive() {
      this.toggleArchive(this.category.id);
      if (this.category.active) {
        this.$message.success("归档成功");
      } else {
        this.$message.success("还原成功");
      }
    },
    ...mapActions(["toggleStar", "deleteCategory", "toggleArchive"])
  }
};
</script>

<style>
.ant-card-meta-description {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
